<template lang="pug">
  .service-package-tile
    .wrap.ui-color-1-bg
      .card.ui-color-3-bg
        .package-name
          span.xs-f-medium.md-f-small.max-at-tweak.bold(v-html="pkg.name")

        .package-image.mt-200m
          img(v-if="pkg.image && pkg.image.url" :src="pkg.image.url")

      .blur
        .package-desc
          p {{ pkg.description }}

        .cta.mt-100m(v-if="locationId")
          button.mr-btn.btn-block(v-if="servicePackage" @click="addPackageToCart")
            span
              strike.strike-price.mr-50m {{ $currencyShort(strikePrice) }}
              span {{ $currencyShort(packagePrice) }}
            span Add to bag

    mr-spinner-veil(v-if="addingThisProduct")

</template>

<script>
  import { mapActions, mapGetters} from 'vuex';
  export default {
    name: "ServicePackageTile",

    props: {
      pkg: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        addingThisProduct: false,
      };
    },

    computed: {
      ...mapGetters('colorbar', [
        'servicePackage',
        'locationId',
      ]),

      packagePrice() {
        return this.servicePackage[this.productCode].price;
      },

      productCode() {
        return this.pkg.product?.code;
      },

      strikePrice() {
        return this.packagePrice / 3 * 4;
      },
    },

    methods: {
      ...mapActions('cart', [
        'addProduct',
      ]),

      ...mapActions('modal', ['showModal']),

      addPackageToCart() {
        this.addingThisProduct = true;
        const payload = {
          productId: this.pkg.product.id,
          locationId: this.locationId,
          eventName: 'Service Package Landing - add to bag clicked for '+ this.productCode
        };

        this.mix_addToCartAndTrackEvent(payload).then(()=> {
          this.showModal({
            component: 'ServicePkgConfirmationModal',
            theme: 'app-modal-xxsmall',
          });
          window.ReactNativeWebView?.postMessage('add-cart');
          this.addingThisProduct = false;
        }).catch(() => {
          this.addingThisProduct = false;
        });
      }
    },

  };
</script>


<style scoped lang="stylus">
.service-package-tile
  max-width 250px
  position relative

  .wrap
    display flex
    flex-direction column
    align-items center
    text-align center
    border-radius 8px
    overflow hidden
    box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.12)

    .card
      display flex
      flex-direction column
      align-items center
      padding 2em 1em 0
      width 100%

      .package-image
        max-width 100%
        img
          width 100%
          max-width 150px
          display block

    .blur
      padding 2em

      .cta
        display flex
        justify-content center

        button.mr-btn
          display flex
          flex-direction column
          align-items center
          padding 0.5em 2em

          strike.strike-price
            opacity 70

</style>